import ValidatePermissions from '@/sections/integration/validate-permission-mixins';

export default {
	mixins: [ValidatePermissions],
	computed: {
		actions() {
			return [
				{
					id: 1,
					action: this.edit,
					title: 'Select to go to integration settings',
					iconClass: 'icon icon-manage',
					label: 'Settings',
					type: 'anchor',
					visible: true,
					disabled: !this.canUpdate
				},
				{
					id: 2,
					action: this.copyIntegration,
					title: 'Select to create a copy of this integration',
					iconClass: 'icon icon-copy',
					label: 'Copy Of',
					type: 'anchor',
					disabled: false,
					visible: true
				},
				{
					id: 3,
					action: this.showtSiteBods,
					title: 'Select to go to site bod view',
					iconClass: 'icon icon-company',
					label: 'SiteBODs',
					type: 'anchor',
					visible: true
				},
				{
					id: 4,
					action: '#',
					iconClass: 'icon icon-history',
					label: 'History',
					title: 'Select to go to integration history',
					type: 'anchor',
					visible: true,
					disabled: true
				},

				{
					id: 5,
					action: this.showTransactions,
					iconClass: 'icon icon-transaction',
					label: 'Transactions',
					title: 'Select to go to the transactions page',
					type: 'anchor',
					visible: true
				}
			];
		}
	}
};
